import { render, staticRenderFns } from "./MarketingDescriptions.vue?vue&type=template&id=1ffd4cea&scoped=true&"
import script from "./MarketingDescriptions.vue?vue&type=script&lang=js&"
export * from "./MarketingDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./MarketingDescriptions.vue?vue&type=style&index=0&id=1ffd4cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd4cea",
  null
  
)

export default component.exports